import { render } from "./App.vue?vue&type=template&id=0500021a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0500021a&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__